/*
 * The (i) button is taller than the label's line, so in a row of fields it would push this field's
 * control below its neighbours'. A zero-height box keeps the label row at the label's own height;
 * the button overflows it, centred on the label, and stays hoverable and focusable.
 */
.labelInfo {
  display: inline-flex;
  align-items: center;
  block-size: 0;
}
